import { createAxios } from './httpService';

const axiosInstance = createAxios();

export const SearchService = {
  search: (key, value) => {
    return axiosInstance.get(`/search?key=${key}&value=${value}`);
  },
};
